/**
 *
 * @param {string} str
 * @returns {string}
 */
export function toTitleCase(str) {
  return str
    .split(/[\s,|-|_]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 *
 * @param {string} str
 * @returns {string}
 */
export function toSlug(str) {
  if (!str) return ''
  return str
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[^a-z0-9\s-]/g, ' ')
    .trim()
    .replace(/[\s-]+/g, '-')
}

/**
 *
 * @param {string} fieldname
 * @returns string
 */
export function titleizeField(fieldname) {
  if (!fieldname) return ''
  return fieldname
    .split('_')
    .map(word => `${word[0].toUpperCase()}${word.slice(1)}`)
    .join(' ')
}

/**
 *
 * @param {string} inputString
 * @returns string
 */
export function titleToSnakeCase(inputString) {
  return inputString.replace(/ /, '_').toLowerCase()
}

/**
 * formatSentence
 * @param {Array<String>} words
 * @returns stringified sentence with commas and 'and' before the last word
 */
export const formatSentence = words => {
  if (words.length === 0) return ''
  if (words.length === 1) return words[0]
  if (words.length === 2) return words.join(' and ')

  const allButLast = words.slice(0, -1).join(', ')
  const lastWord = words[words.length - 1]

  return `${allButLast}, and ${lastWord}`
}

/**
 *
 * @param {string} str
 * @param {number} num
 * @returns string
 */
export const truncateString = (str, num = 100) => {
  if (str.length <= num) {
    return str
  } else {
    return `${str.slice(0, num)}...`
  }
}

/**
 *
 * @param {string} phoneString
 * @returns string
 */
export function formatPhoneNumber(phoneString) {
  if (!phoneString) {
    return ''
  }

  // If the phone starts with a "+", assume it's an international number and return as is
  if (phoneString.charAt(0) === '+') {
    return phoneString
  }

  // Strip all non-digit chars
  let value = phoneString.replaceAll(/\D/g, '')

  const first = value.substring(0, 3)
  const middle = value.substring(3, 6)
  const last = value.substring(6, 10)

  if (value.length > 6) {
    value = `(${first}) ${middle} - ${last}`
  } else if (value.length > 3) {
    value = `(${first}) ${middle}`
  } else if (value.length > 0) {
    value = `(${first}`
  }

  return value
}
